import { render, staticRenderFns } from "./AlbumsEn.vue?vue&type=template&id=e9a524f6&"
import script from "./AlbumsEn.vue?vue&type=script&lang=js&"
export * from "./AlbumsEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports